module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/secondary_address.js
// module id = 1554
// module chunks = 0